import type { CSSProperties } from "react";

interface BrandWordmarkProps {
  className?: string;
  decorative?: boolean;
  style?: CSSProperties;
}

export function BrandWordmark({
  className = "",
  decorative = false,
  style,
}: BrandWordmarkProps) {
  return (
    <span
      className={`inline-flex items-baseline whitespace-nowrap ${className}`}
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : "172X Pipeline"}
      aria-hidden={decorative ? true : undefined}
      style={style}
    >
      <span
        aria-hidden="true"
        className="font-sans text-lg font-semibold tracking-[-0.04em]"
      >
        172X
      </span>
      <span
        aria-hidden="true"
        className="mx-[0.34em] font-sans text-lg font-semibold leading-none tracking-[-0.04em]"
      >
        Pipeline
      </span>
    </span>
  );
}
